<template>
  <v-container class="about">
    <hero :data="data" />
    <v-row>
      <v-col align="center" justify="center">
        <h2 class="display-1 font-weight-bold">{{ data.body[0].primary.title1[0].text }}</h2>
        <v-divider class="mt-5 mx-auto" style="max-width: 100px; border-width: 2px" />
      </v-col>
      <v-col cols="12">
        <p class="text-center">{{ data.body[0].primary.subtitle[0].text }}</p>
      </v-col>
      <!-- start numbered card -->
      <v-col
        cols="6"
        md="3"
        class="text-center"
        v-for="(cap, index) in data.body[0].items"
        :key="index"
      >
        <h2 class="display-1 font-weight-bold">{{ cap.number | kFormatter }} +</h2>
        <div class="title font-weight-light">{{ cap.description[0].text }}</div>
      </v-col>
      <!-- end numbered card -->
    </v-row>
    <v-row justify="space-between">
      <v-col v-for="(i, index) in data.body[1].items" :key="index" cols="12" md="3" class="d-flex">
        <v-card>
          <v-img
            :src="'https://res.cloudinary.com/twodm/image/fetch/' + i.image.url"
            contain
            height="200"
          ></v-img>
          <v-card-title>{{ i.type[0].text }}</v-card-title>
          <v-card-text>{{ i.description[0].text }}</v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!--      <v-col>-->
    <!--        <v-img-->
    <!--          :src="'https://res.cloudinary.com/twodm/image/fetch/' + i.image.url"-->
    <!--          lazy-src="https://picsum.photos/id/11/10/6"-->
    <!--          contain-->
    <!--          height="300"-->
    <!--        >-->
    <!--        </v-img>-->
    <!--      </v-col>-->
    <!--      <v-col :order="index%2 === 0 && !$vuetify.breakpoint.mobile ? 'last' : 'first'">-->
    <!--        <div class="d-flex flex-no-wrap justify-space-between">-->
    <!--          <div>-->
    <!--            <h3 class="title">-->
    <!--              {{ i.type[0].text  }}-->
    <!--            </h3>-->
    <!--            <h4 class="subtitle-1">-->
    <!--              {{ i.description[0].text }}-->
    <!--            </h4>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </v-col>-->
    <v-row>
      <v-col cols="12">
        <v-tabs
          v-model="tab"
          background-color="transparent"
          icons-and-text
          centered
          show-arrows
          grow
        >
          <v-tabs-slider></v-tabs-slider>

          <v-tab v-for="item in data.tabs" :key="item">
            {{ item.tab_name[0].text }}
            <v-icon>{{ item.icon[0].text }}</v-icon>
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item v-for="i in data.tabs" :key="i">
            <v-card flat>
              <v-container>
                <v-row justify="space-between">
                  <v-col>
                    <v-img
                      :src="'https://res.cloudinary.com/twodm/image/fetch/' + i.image.url"
                      lazy-src="https://picsum.photos/id/11/10/6"
                      contain
                      height="300"
                    ></v-img>
                  </v-col>
                  <v-col>
                    <div class="d-flex flex-no-wrap justify-space-between">
                      <div>
                        <v-card-title class="font-weight-bold">{{ i.subtitle[0].text }}</v-card-title>
                        <v-card-text>
                          <prismic-rich-text :field="i.body" />
                        </v-card-text>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
              <v-card-text></v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
    <v-row>
      <v-col align="center">
        <p class="text-center">
          {{ $t('about.section-3.copy') }}
          <a href="https://add-data.io" target="_blank">{{ $t('about.section-3.cta') }}</a>
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" align="center" justify="center">
        <h1>{{ $t('common.contact-us') }}</h1>
      </v-col>
      <v-col>
        <v-btn color="indigo" block dark id="open_intercom_chat">{{ $t('common.book-a-demo')}}</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Hero from '../components/hero';

export default {
  name: 'About',
  components: { Hero },
  data: () => ({
    data: '',
    tab: null,
    text: 'hello world',
  }),
  methods: {
    getContent() {
      this.$prismic.client
        .getSingle('about', { lang: this.$i18n.locale })
        .then((document) => {
          this.data = document.data;
          this.loading = false;
        });
    },
  },
  created() {
    this.getContent();
  },
};
</script>
